import React from 'react'
import PageGetTenant from '../../pages/PageGetTenant'
import { TenantlessAppApiProvider } from './AppApi'

// function to get tenant ID from path (first part of path)
const getTenantId = () => {
    //get the path
    let path = window.location.pathname
    //remove leading slash
    if (path.startsWith('/')) {
        path = path.substring(1)
    }
    if (path == '') {
        throw new Error('No tenant ID in path')
    }
    const parts = path.split('/')
    return parts[0]
}

const tenantIDContext = React.createContext<string | undefined>(undefined)
const useTenantID = () => {
    const contextInstance = React.useContext(tenantIDContext)
    if (contextInstance === undefined) {
        throw new Error('useContext must be used within a ContextProvider')
    }
    return contextInstance
}
const AppTenantIDProvider = (props: { children: React.ReactNode }) => {
    const ContextProvider = tenantIDContext.Provider
    //get the tenant id & environment
    let value = null
    let tenantID = null
    try {
        tenantID = getTenantId()
    } catch (e) {
        return <TenantlessAppApiProvider><PageGetTenant /></TenantlessAppApiProvider>
    }
    return <ContextProvider value={tenantID}>{props.children}</ContextProvider>
}

export { AppTenantIDProvider as default, useTenantID }

